import {
  Icons,
  Spinner,
  Typography,
  Stack,
  colorOrToken,
  tokens,
} from '@cast/design-system';

type ConnectionItemStatus = 'pending' | 'in_progress' | 'completed';

export type ConnectionProgressItem = {
  key: string;
  label: string;
  status: ConnectionItemStatus;
};

const ConnectionProgressItemIcon = ({
  status,
}: {
  status: ConnectionProgressItem['status'];
}) => {
  if (status === 'completed') {
    return (
      <Icons.CheckCircle
        size={14}
        weight="fill"
        color={colorOrToken('green.500', tokens.theme.fg.status.success)}
      />
    );
  }
  if (status === 'in_progress') {
    return <Spinner size={14} color="secondary" />;
  }
  return (
    <Icons.Circle
      size={14}
      color={colorOrToken('grey.300', tokens.theme.fg.structural.secondary)}
    />
  );
};

export const ConnectionProgressRow = ({
  item,
}: {
  item: ConnectionProgressItem;
}) => (
  <Stack
    direction="row"
    gap={4}
    pl={16}
    alignItems="center"
    data-testid={`connection-status-${item.key}`}
    data-status={item.status}
  >
    <ConnectionProgressItemIcon status={item.status} />
    <Typography variant="P12R" color="textSecondary">
      {item.label}
    </Typography>
  </Stack>
);
